export const FORM_VIEWED_EVENT = 'form_viewed';
export const FORM_FIELD_INTERACTED = 'form_field_interacted';
export const FEATURE_VIEWED_EVENT = 'feature_viewed';
export const LINK_VIEWED_EVENT = 'link_viewed';

export type EventType =
  | typeof FORM_VIEWED_EVENT
  | typeof FEATURE_VIEWED_EVENT
  | typeof LINK_VIEWED_EVENT;
